import React from 'react'
import ModalWrapper from './ModalWrapper'

const isUploadSource = (source) => source === 'mediaUploadFailed' ||
  source === 'unsupportedSoundType' ||
  source === 'unsupportedImageType' ||
  source === 'fileTooLarge'

const WhitelistErrorModal = (props) => {
  const { whitelistErrorSource, whitelistErrorMessage } = props
  return (
    <div className='cloudinaryError-modalContainer'>
      <ModalWrapper
        {...props}
        title={isUploadSource(whitelistErrorSource) ? 'Upload Error' : 'Network Error'}
        modalStyle='light'
      >
        <div className='cloudinaryError-modalContent'>

          {whitelistErrorSource === 'mediaUploadFailed' && (
            <div className='cloudinaryError-modalContent-header'>
              Failed to upload your file. Please check your internet connection and try again.
            </div>
          )}

          {whitelistErrorSource === 'unsupportedSoundType' && (
            <div className='cloudinaryError-modalContent-header'>
              {whitelistErrorMessage || 'The audio file format is not supported. Supported formats: mp3, wav, ogg, m4a, flac, aac, webm, mp4.'}
            </div>
          )}

          {whitelistErrorSource === 'unsupportedImageType' && (
            <div className='cloudinaryError-modalContent-header'>
              {whitelistErrorMessage || 'The image file format is not supported. Supported formats: png, jpg, jpeg, webp, avif, bmp, gif.'}
            </div>
          )}

          {whitelistErrorSource === 'fileTooLarge' && (
            <div className='cloudinaryError-modalContent-header'>
              {whitelistErrorMessage || 'The file is too large to upload.'}
            </div>
          )}

          {whitelistErrorSource === 'imageSearch' && (
            <div className='cloudinaryError-modalContent-header'>
              Failed to search for images because your network internet is blocking access to Plickers&apos; image search.
            </div>
          )}

          {whitelistErrorSource === 'imageSearch' && (
            <div>
              The good news is, your IT administrator should be able to fix this.
              {' '}
              <br />
              If you send them the following message it should help them:
              {' '}
              <br />
              <div className='cloudinaryError-modalContent-messageContents'>
                Plickers requires the following domains to be whitelisted:
                <br />
                <br />
                <b>*.giphy.com</b>
                {' '}
                – used for GIPHY search and hosting
                <br />
                <b>*.googleapis.com</b>
                {' '}
                – used for YouTube search
                <br />
                <b>*.youtube.com</b>
                {' '}
                – used for YouTube video delivery
                <br />
                <br />
                Some of these domains are currently inaccessible, restricting Plickers&apos; functionality.
                <br />
              </div>

              If you have any questions, don&apos;t hesitate to contact support help@plickers.com
            </div>
          )}

          {whitelistErrorSource === 'gifSearch' && (
            <div>
              Failed to complete gif search. Please make sure giphy.com is whitelisted in your network.
            </div>
          )}
        </div>

      </ModalWrapper>

    </div>
  )
}

export default WhitelistErrorModal
